import RoleTable from "/src/features/administration/role/components/RoleTable/RoleTable";

function RoleList() {

    return <RoleTable/>
}

export default RoleList;